import { render } from "./PdfRowCustomInput.vue?vue&type=template&id=60f72d6f&ts=true"
import script from "./PdfRowCustomInput.vue?vue&type=script&lang=ts"
export * from "./PdfRowCustomInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__